<template>
	<div class="prizes-page">
		<div class="container">
			<div class="prize-list" v-if="$store.state.campaign.prizes && $store.state.campaign.prizes.length > 0">
				<div class="prize-item" v-for="(prize, index) of $store.state.campaign.prizes" :key="index">
					<div class="prize-image">
						<img :src="prize.images[0]" v-if="prize.images && prize.images.length > 0" />
					</div>
					<div class="prize-detail">
						<h2 class="prize-title" v-if="prize.name">{{ prize.name }}</h2>
						<div class="prize-description" v-html="prize.description"></div>
						<footer class="prize-footer">
							<div class="sponsor" v-if="prize.sponsor"><strong>Sponsored by:</strong> {{ prize.sponsor }}</div>
							<div class="social-identifiers">#ConnectedexperienceHashtag</div>
						</footer>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.prizes-page {
	width: 100%;

	.prize-list {
		list-style: none;

		.prize-item {
			margin: 25px auto;
			background-color: #fff;
			box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
			padding: 20px;
			display: flex;
			font-size: 23px;

			.prize-image {
				width: 30%;
				height: 0;
				padding-bottom: 30%;
				margin-right: 35px;
				flex: 0 0 auto;
				position: relative;

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
				}
			}

			.prize-detail {
				flex: 1 1 auto;
				display: flex;
				flex-direction: column;
			}

			.prize-title {
				font-size: 23px;
			}

			.prize-description {
				flex: 1 1 auto;
				margin: 0.75em 0;
			}

			.social-identifiers {
				font-weight: bold;
			}
		}
	}
}
</style>
